export default __webpack_public_path__ + "static/media/truckcr.82f91916.jpg";